var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72578 1.11132C8.07215 0.962895 8.45854 0.962895 8.80492 1.11132L14.9911 3.76318C15.3375 3.9116 15.7239 3.9116 16.0703 3.76318L21.7993 1.30748C22.0237 1.21109 22.2782 1.24069 22.4782 1.38642C22.6781 1.53215 22.7973 1.77492 22.7961 2.03402V16.9519C22.7962 17.5886 22.4344 18.1613 21.8826 18.3977L16.0703 20.8887C15.7239 21.0371 15.3375 21.0371 14.9911 20.8887L8.80492 18.2368C8.45854 18.0884 8.07215 18.0884 7.72578 18.2368L1.9968 20.6884C1.77233 20.7848 1.51781 20.7552 1.31786 20.6094C1.11792 20.4637 0.998754 20.2209 0.999989 19.9618V5.04811C0.999889 4.41137 1.36169 3.83874 1.91349 3.6023L7.72578 1.11132Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5307 3.87422V20.9997",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26534 1.00024V18.1258",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56747 6.47032L5.45359 5.73249L5.45359 7.73901L3.56743 8.5415L3.56747 6.47032Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56747 10.4703L5.45359 9.73249L5.45359 11.739L3.56743 12.5415L3.56747 10.4703Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56747 14.4703L5.45359 13.7325L5.45359 15.739L3.56743 16.5415L3.56747 14.4703Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegend);
export default __webpack_public_path__ + "static/media/legend.ca7fa8fcabbe6fcac992581b1ab5b4d3.svg";
export { ForwardRef as ReactComponent };